import { Controller } from "@hotwired/stimulus"

// The pagination's form (shared/_pagination): choosing how many rows a page
// holds shows the list at once, from its first page. Without JavaScript the
// form's "Prejsť" button does the same.
export default class extends Controller {
  submit() {
    const page = this.element.querySelector("[data-jump]")
    if (page) page.value = "1"
    this.element.requestSubmit()
  }
}
